















import Spinner from '@/components/atoms/Spinner.vue'
import { log } from '@/log'
import AuthError from '@spa/hl-app/components/error/AuthError.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { User } from '@spa/store/modules/user/types'
import { Component, Mixins } from 'vue-mixin-decorator'
import { Route } from 'vue-router'

type AuthStatus = 'processing' | 'succeeded' | 'failed'

@Component({
  components: {
    AuthError,
    Spinner,
  },
})
export default class App extends Mixins<PluginMixin>(PluginMixin) {
  authStatus: AuthStatus = 'processing'

  async created() {
    await this.$store.dispatch('view/startLoading')

    /**
     * ルーティングに定義されたallowGuest, requireLoginのハンドリング
     * なお、vuexのuser/get時にcallWithAuthによってo, hashクエリの解釈と自動ログインが実行される
     */
    try {
      const { o, hash } = this.$route.query
      const existAutoLoginParams = o && hash

      // ゲストが許可されているページでは、o, hashがなければ処理を終了
      // vuexのuser/getに進んでしまうとa cookieなしのためcallWithAuthでエラーになってしまうことに注意
      if (this.allowGuest(this.$route) && !existAutoLoginParams) {
        this.authStatus = 'succeeded'
        await this.$store.dispatch('view/stopLoading')

        return
      }

      // o, hashクエリが存在すればcallWithAuthによって自動ログインが実行される
      await this.$store.dispatch('user/get')
      if (this.$store.getters['user/hasError'] || !this.user) {
        throw new Error('auto login error')
      }

      if (this.needLogin(this.$route)) {
        throw new Error('should be a registered user')
      }
      this.appendRequireLoginHook()

      this.authStatus = 'succeeded'
    } catch (error) {
      log.error({ error })
      this.authStatus = 'failed'
    } finally {
      await this.$store.dispatch('view/stopLoading')
    }
  }

  get user(): User | undefined {
    return this.$store.state.user.user
  }

  get wrapperClass() {
    return {
      'hlapp-spa': true,
      'l-spa-adjust--loading': this.isLoading,
    }
  }

  get isLoading(): boolean {
    return this.$store.state.view.isLoading
  }

  allowGuest(route: Route): boolean {
    return route.matched.some(r => r.meta.allowGuest)
  }

  needLogin(route: Route): boolean {
    return route.matched.some(r => r.meta.requireLogin)
      && this.user !== undefined
      && this.user.user_status !== 'registered'
  }

  /**
   * SPA内でのページ遷移でrequireLoginなページに到達した場合にAuthErrorにする
   *
   * オートログイン、会員状態（本会員か）の取得中にローディングを表示したかったため、
   * SPAの初期化やbeforeEachでのチェックではなく、App.vueで
   * - オートログイン
   * - 会員状態の取得
   * - 今のページがrequireLoginであるかの判定
   * - 以降のページ遷移のためのrouter hookの登録
   * を行う設計を選択した
   */
  appendRequireLoginHook() {
    this.$router.beforeEach((to, _from, next) => {
      if (this.needLogin(to)) {
        this.authStatus = 'failed'
      } else {
        next()
      }
    })
  }
}
